// extracted by mini-css-extract-plugin
module.exports = {"searchVerticalRecosContainer":"gW","productsContainer":"hW","searchVerticalReco":"iW","heading":"jW"};